import { render, staticRenderFns } from "./GroupsPage.vue?vue&type=template&id=3b982011&scoped=true&"
import script from "./GroupsPage.vue?vue&type=script&lang=js&"
export * from "./GroupsPage.vue?vue&type=script&lang=js&"
import style0 from "@/views/SyncPage/Tabs/DataPage/Tabs/PeoplePage/style.scss?vue&type=style&index=0&id=3b982011&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b982011",
  null
  
)

export default component.exports